import * as t from 'io-ts';
import { DateFromUnixTime } from 'io-ts-types';

export const quota = t.type({
  entity: t.string,
  max: t.number,
  current: t.number,
});

const setupIntentCodec = t.type({
  clientSecret: t.string,
  id: t.string,
  status: t.string,
  usage: t.string,
});

const paymentIntentCodec = t.type({
  status: t.string,
  clientSecret: t.string,
  id: t.string,
});

export const stripeCodec = t.type({
  id: t.string,
  pendingSetupIntent: t.union([setupIntentCodec, t.string, t.null, t.undefined]),
  status: t.string,
  pendingUpdate: t.union([t.string, t.null]),
  latestInvoice: t.type({
    id: t.string,
    paymentIntent: t.union([paymentIntentCodec, t.null, t.undefined]),
  }),
});

export const stripeResponseCodec = t.type({
  data: stripeCodec,
});

export const failureCodec = t.type({
  reason: t.string,
  code: t.string,
  invoiceUrl: t.string,
  intentSecret: t.string,
  paymentMethod: t.union([t.string, t.null]),
});

export const nextSubscription = t.type({
  currentPeriodEnd: DateFromUnixTime,
  features: t.array(t.string),
  isFree: t.boolean,
  quotas: t.array(quota),
  status: t.string,
  failure: t.union([failureCodec, t.undefined]),
});

const baseSubscription = t.type({
  currentPeriodEnd: DateFromUnixTime,
  features: t.array(t.string),
  quotas: t.array(quota),
  isFree: t.boolean,
  failure: t.union([failureCodec, t.undefined]),
  status: t.string,
  hasPaymentMethod: t.boolean,
  nextSubscription: t.union([
    t.array(nextSubscription),
    t.undefined,
  ]),

});

export const subscriptionCodec = baseSubscription;
